import { useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";

import { useAlert } from "@/hooks/useAlert";
import { PUBLIC_AUTHORIZATION, TOKEN_URL } from "@/utils/apiUrls";
import { AlertTypes, setAuthAtom } from "@/utils/atoms";

/**
 * Authenticates as a public user and sets the access token.
 *
 * This hook retrieves an access token for a public user from the backend
 * It's a simpler version of useAnonymousLogin that only handles authentication
 * withoutany additional operations.
 */
export const usePublicCustomerLogin = () => {
  const setAuth = useSetAtom(setAuthAtom);
  const showAlert = useAlert();
  const { t } = useTranslation();

  const logInAsPublicCustomer = () =>
    // Get an OAuth token by using the public user
    fetch(`${TOKEN_URL.toString()}?grant_type=client_credentials&scope=all`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: PUBLIC_AUTHORIZATION,
      },
    })
      .then(async (res: any) => {
        const anonymousLoginData = await res.json();

        if (anonymousLoginData.access_token === undefined) {
          throw new Error("No access token received");
        }

        setAuth({
          accessToken: anonymousLoginData.access_token,
          refreshToken: anonymousLoginData.refresh_token,
          isAnonymous: true,
        });
      })
      .catch((e) => {
        showAlert({
          text: t("Error.agentLogin.failed"),
          type: AlertTypes.error,
        });
      });

  return logInAsPublicCustomer;
};
